<template>
  <v-container id="home_menu" fluid tag="section" class="">
    <v-alert
      icon="mdi-shield-lock-outline"
      prominent
      text
      type="info"
      border="left"
      colored-border
      elevation="2"
      class="elegant-user-card"
    >
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <div class="user-info-section">
            <h2 class="user-title">ผู้ใช้งานระบบ : {{ user.user_ID }}</h2>
          </div>
          <div>
            <h3 class="user-name">
              ชื่อผู้ใช้งาน : {{ user.user_firstname }}
              {{ user.user_lastname || "" }}
            </h3>
          </div>
          <h3 class="user-status">สถานะ : {{ user.user_status }}</h3>
        </v-col>
        <v-col cols="12" md="6">
          <div align="right" class="action-buttons">
            <v-btn
              class="elegant-btn edit-btn"
              fab
              dark
              color="warning"
              outlined
              @click.native="userUpdate()"
            >
              <v-icon dark>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              v-if="user.userauthorityAdmin === '1'"
              class="elegant-btn calendar-btn"
              fab
              dark
              color="warning"
              outlined
              @click="endCalendar()"
            >
              <v-icon dark>
                mdi-calendar
              </v-icon>
            </v-btn>

            <v-btn
              v-if="user.userauthorityAdmin === '1'"
              class="elegant-btn update-btn"
              fab
              dark
              color="warning"
              outlined
              @click="clearUpdate()"
            >
              <v-icon dark>
                mdi-update
              </v-icon>
            </v-btn>

            <v-btn
              v-if="user.userauthorityAdmin === '1'"
              class="elegant-btn admin-btn"
              fab
              dark
              color="warning"
              outlined
              to="/admin/userAdmin"
            >
              <v-icon dark>
                mdi-account-convert
              </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-alert>

    <v-row no-gutters>
      <v-col cols="12" md="12" v-if="user.userauthorityAssitantTeach === '1'">
        <AlertAssistant_teacher />
      </v-col>
      <v-col cols="12" md="12" v-if="user.userauthority_govem !== '1'">
        <AlertAssistant_teacher2 />
        <AlertAssistant_teacher3_licence />
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="pa-2"
        v-if="user.userauthorityAdmin === '1'"
      >
        <div class="text-center navigation-bar">
          <v-btn rounded color="blue" href="#manpowers" class="nav-btn"
            >งานอัตรากำลัง</v-btn
          >
          <v-btn rounded color="error darken-2" href="#move38" class="nav-btn"
            >ย้าย 38 ค.(2)</v-btn
          >
          <v-btn rounded color="pink" href="#moveTeach" class="nav-btn"
            >ย้ายครู</v-btn
          >
          <v-btn rounded color="purple" href="#moveDirector" class="nav-btn"
            >ย้ายผู้บริหาร</v-btn
          >
          <v-btn rounded color="green" href="#regisSedirector" class="nav-btn"
            >คัดเลือก รอง ผอ.</v-btn
          >
          <v-btn
            rounded
            color="green darken-4"
            href="#regisdirector"
            class="nav-btn"
            >คัดเลือก ผอ.</v-btn
          >
          <v-btn rounded color="warning" href="#assistantTeach" class="nav-btn"
            >ครูผู้ช่วย</v-btn
          >
          <v-btn rounded color="brown" href="#newsanddoc" class="nav-btn"
            >ข่าวสาร</v-btn
          >
        </div>
      </v-col>

      <v-col cols="12" md="12" v-if="user.userauthorityAdmin === '1'">
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header"
          >
            <h2 class="section-title">ส่วนหลักของระบบ</h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="4"
              v-if="user.userauthorityAdmin === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar color="teal" dark class="section-toolbar">
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon>
                    ข้อมูลสถานศึกษา
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in college_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="4"
              v-if="user.userauthorityAdmin === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar color="teal" dark class="section-toolbar">
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon>
                    ผู้ใช้งานระบบ
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in user_system_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="4"
              v-if="user.userauthorityAdmin === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar color="teal" dark class="section-toolbar">
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-3-circle</v-icon>
                    ข้อมูลงานบุคคล
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in user_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" v-if="user.userauthority_govem === '1'">
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header"
          >
            <h2 class="section-title">ส่วนหลักของระบบ</h2>
          </v-alert>

          <v-row no-gutters>
            <v-col cols="12" md="4" class="pa-1">
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar color="teal" dark class="section-toolbar">
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon>
                    ข้อมูลสถานศึกษา
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in college_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col cols="12" md="4" class="pa-1">
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar color="teal" dark class="section-toolbar">
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon>
                    ผู้ใช้งานระบบ
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in user_system_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col cols="12" md="4" class="pa-1">
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar color="teal" dark class="section-toolbar">
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-3-circle</v-icon>
                    ข้อมูลงานบุคคล
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in filteredUserItems"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-row no-gutters>
        <v-col
          cols="12"
          md="12"
          v-if="user.userauthorityAdmin === '1'"
          class="pa-1"
        >
          <v-card tile outlined class="elegant-section-card branch-section">
            <v-alert
              text
              dense
              color="indigo"
              icon="mdi-clock-fast"
              border="left"
              class="mb-0 section-header indigo-header"
            >
              <h2 class="section-title">สาขาวิชา</h2>
            </v-alert>

            <v-list class="elegant-list">
              <v-list-item-group>
                <v-list-item
                  v-for="(item, i) in about_brach"
                  :key="i"
                  :to="item.to"
                  class="elegant-list-item"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" class="list-icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="item.text"
                      class="list-title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

      <v-col
        cols="12"
        md="12"
        v-if="user.userauthorityManpower === '1'"
        class="pa-1"
      >
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header blue-header"
          >
            <h2 class="section-title" id="manpowers">งานอัตรากำลัง</h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityManpower === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="blue"
                  dark
                  class="section-toolbar blue-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon
                    >ระบบอัตรากำลัง รายงานสถานศึกษา
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in human_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityManpower === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="blue"
                  dark
                  class="section-toolbar blue-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon
                    >ระบบอัตรากำลัง พิจารณาย้าย
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in manpower_move"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="12"
        v-if="user.userauthorityManpower === '1'"
        class="pa-1"
      >
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header blue-header"
          >
            <h2 class="section-title" id="manpowers">
              งานสำรวจสาขาวิชาตำแหน่งว่าง
            </h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="12"
              v-if="user.userauthorityManpower === '1'"
              class="pa-1"
            >
              <v-list class="elegant-list">
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, i) in humanreport_items"
                    :key="i"
                    :to="item.to"
                    class="elegant-list-item"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon" class="list-icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.text"
                        class="list-title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="12"
        v-if="user.userauthorityMoveTeach === '1'"
        class="pa-1"
      >
        <v-card tile outlined class="elegant-section-card error-section">
          <v-alert
            text
            color="error darken-2"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header error-header"
          >
            <h2 class="section-title" id="move38">
              ระบบการย้าย
              <span class="red--text special-text" id="fontsizest"
                >บุคลากรทางการศึกษาอื่นตามมาตรา 38 ค.(2)</span
              >
            </h2>
          </v-alert>

          <v-list class="elegant-list">
            <v-list-item-group>
              <v-list-item
                v-for="(item, i) in movement38_items"
                :key="i"
                :to="item.to"
                class="elegant-list-item"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon" class="list-icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.text"
                    class="list-title"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" v-if="user.userauthorityMoveTeach === '1'">
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header pink-header"
          >
            <h2 class="section-title" id="moveTeach">
              ย้าย
              <span class="red--text special-text" id="fontsizest"
                >สายการสอน</span
              >
            </h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="4"
              v-if="user.userauthorityMoveTeach === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="pink"
                  dark
                  class="section-toolbar pink-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon>
                    ระบบการย้ายข้าราชการครู สายการสอน
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in movement_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="4"
              v-if="user.userauthorityMoveTeach === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="pink"
                  dark
                  class="section-toolbar pink-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon>
                    เงือนไขสาขาวิชาสถานศึกษา
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in condition_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>

              <v-card tile outlined class="elegant-section-card mt-3">
                <v-toolbar
                  color="pink"
                  dark
                  class="section-toolbar pink-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-3-circle</v-icon
                    >คณะกรรมการ สอจ.
                  </v-toolbar-title>
                </v-toolbar>
                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in commiteevecpro"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="4"
              v-if="user.userauthorityMoveTeach === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="pink"
                  dark
                  class="section-toolbar pink-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-4-circle</v-icon>
                    หนังสือราชการ
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in official_book"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" v-if="user.userauthority_govem === '1'">
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header blue-toolbar"
          >
            <h2 class="section-title" id="moveTeach">
              กรอบอัตรากำลัง
              <span class="red--text special-text" id="fontsizest"
                >พนักงานราชการ</span
              >
            </h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="6"
              v-if="user.userauthority_govem === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="blue"
                  dark
                  class="section-toolbar blue-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon>
                    ระบบบริหารงานกรอบอัตรากำลัง
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in movement_govem_manpoweritems"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              v-if="user.userauthority_govem === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="blue"
                  dark
                  class="section-toolbar blue-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon>
                    รายงานค่าตอบแทนพนักงานราชการ ประจำปี
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in movement_govem_manpowerSalaryitems"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" v-if="user.userauthority_govem === '1'">
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header purple-header"
          >
            <h2 class="section-title" id="moveTeach">
              ย้าย
              <span class="red--text special-text" id="fontsizest"
                >พนักงานราชการ</span
              >
            </h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="4"
              v-if="user.userauthority_govem === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="purple"
                  dark
                  class="section-toolbar purple-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon>
                    ระบบการย้าย พนักงานราชการ
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in movement_govem_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="4"
              v-if="user.userauthority_govem === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="purple"
                  dark
                  class="section-toolbar purple-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon>
                    เงือนไขสาขาวิชาสถานศึกษา
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in condition_govem_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="4"
              v-if="user.userauthority_govem === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="purple"
                  dark
                  class="section-toolbar purple-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-4-circle</v-icon>
                    หนังสือราชการ
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in official_book_govem"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" v-if="user.userauthorityMoveManage === '1'">
        <v-card tile outlined class="elegant-section-card purple-section">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header purple-header"
          >
            <h2 class="section-title" id="moveDirector">
              ย้าย
              <span class="red--text special-text" id="fontsizest"
                >สายงานบริหารสถานศึกษา</span
              >
            </h2>
          </v-alert>

          <v-list class="elegant-list">
            <v-list-item-group>
              <v-list-item
                v-for="(item, i) in movement_manage_items"
                :key="i"
                :to="item.to"
                class="elegant-list-item"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon" class="list-icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.text"
                    class="list-title"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="12"
        v-if="user.userauthorityAssessSedirector === '1'"
      >
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header green-header"
          >
            <h2 class="section-title" id="regisSedirector">
              คัดเลือก ตำแหน่ง รองผู้อำนวยการวิทยาลัย
            </h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityAssessSedirector === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="green"
                  dark
                  class="section-toolbar green-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon
                    >ระบบสมัครสอบตำแหน่ง รองผู้อำนวยการวิทยาลัย
                  </v-toolbar-title>
                </v-toolbar>
                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in appoint_sedirector"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityAssessSedirector === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="green"
                  dark
                  class="section-toolbar green-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon
                    >ระบบสมัครสอบตำแหน่ง รองผู้อำนวยการวิทยาลัย
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in appoint_sedirector2"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="12"
        v-if="user.userauthorityAssessSedirector === '1'"
      >
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="green darken-4"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header green-dark-header"
          >
            <h2 class="section-title" id="regisdirector">
              คัดเลือก ตำแหน่ง ผู้อำนวยการวิทยาลัย
            </h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityAssessSedirector === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="green darken-4"
                  dark
                  class="section-toolbar green-dark-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon
                    >ระบบสมัครสอบตำแหน่ง ผู้อำนวยการวิทยาลัย
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in appoint_director"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityAssessSedirector === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="green darken-4"
                  dark
                  class="section-toolbar green-dark-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon
                    >ระบบสมัครสอบตำแหน่ง ผู้อำนวยการวิทยาลัย
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in appoint_director2"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" v-if="user.userauthorityAssitantTeach === '1'">
        <v-card outlined class="elegant-main-card">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header orange-header"
          >
            <h2 class="section-title" id="assistantTeach">ครูผู้ช่วย</h2>
          </v-alert>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityAssitantTeach === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="orange"
                  dark
                  class="section-toolbar orange-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-1-circle</v-icon
                    >ระบบครูผู้ช่วย (เรียกรายงานตัวครูผู้ช่วย)
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in prepare_items"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              v-if="user.userauthorityAssitantTeach === '1'"
              class="pa-1"
            >
              <v-card tile outlined class="elegant-section-card">
                <v-toolbar
                  color="orange"
                  dark
                  class="section-toolbar orange-toolbar"
                >
                  <v-toolbar-title class="toolbar-title">
                    <v-icon class="section-icon">mdi-numeric-2-circle</v-icon>
                    ระบบประเมินครูผู้ช่วย
                  </v-toolbar-title>
                </v-toolbar>

                <v-list class="elegant-list">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in prepare_items_committee"
                      :key="i"
                      :to="item.to"
                      class="elegant-list-item"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" class="list-icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                          class="list-title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" class="pa-1">
        <v-card tile outlined class="elegant-section-card brown-section">
          <v-alert
            text
            color="white"
            icon="mdi-clock-fast"
            border="left"
            class="mb-0 section-header brown-header"
          >
            <h2 class="section-title" id="newsanddoc">ข่าวสารและคู่มือระบบ</h2>
          </v-alert>

          <v-list class="elegant-list">
            <v-list-item-group>
              <v-list-item
                v-for="(item, i) in news_manual"
                :key="i"
                :to="item.to"
                class="elegant-list-item"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon" class="list-icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.text"
                    class="list-title"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <!-- V-model userdialog -->
    <v-layout row justify-center>
      <v-dialog v-model="edituserdialog" persistent max-width="80%">
        <v-card class="mx-auto pa-6 elegant-dialog" elevation="2">
          <base-material-card
            color="yellow"
            icon="mdi-clipboard-text"
            title="เปลี่ยนรหัสผ่าน"
            class="px-5 py-3 text_google dialog-header"
            elevation="2"
          >
          </base-material-card>
          <v-card-text class="dialog-content">
            <v-form ref="edituserform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <div class="user-info">
                      {{ edituser.user_name }} {{ edituser.user_firstname
                      }}{{ edituser.user_lastname }}
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Password"
                      v-model="edituser.user_password"
                      type="password"
                      class="elegant-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Confirm Password"
                      v-model="edituser.user_confirmpassword"
                      type="password"
                      required
                      :rules="[v => v == edituser.user_password]"
                      class="elegant-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider class="elegant-divider"></v-divider>
                  </v-flex>
                </v-layout>
              </v-container>
              <small class="required-text">* จำเป็น</small>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn
              large
              @click.stop="edituserdialog = false"
              rounded
              class="cancel-btn"
            >
              <v-icon dark>mdi-close</v-icon>ยกเลิก
            </v-btn>
            <v-btn
              large
              color="amber lighten-1"
              @click.stop="edituserSubmit()"
              rounded
              class="submit-btn"
            >
              <v-icon dark>mdi-pencil</v-icon>&nbsp;แก้ไข
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- V-model endCalendardialog -->
    <v-layout row justify-center>
      <v-dialog v-model="endCalendardialog" persistent max-width="50%">
        <v-card class="mx-auto pa-6 elegant-dialog" elevation="2">
          <base-material-card
            color="warning"
            icon="mdi-clipboard-text"
            title="ยกเลิกกำหนดการระบบทั้งหมด"
            class="px-5 py-3 text_google dialog-header"
            elevation="2"
          >
          </base-material-card>
          <v-card-text class="dialog-content">
            <v-form ref="endCalendarform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <v-text-field
                      outlined
                      label="Confirm Password"
                      v-model="confirmPassword"
                      required
                      :rules="[v => v == 'Th07111988@7']"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      hint="At least 12 characters"
                      counter
                      @click:append="show1 = !show1"
                      class="elegant-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider class="elegant-divider"></v-divider>
                  </v-flex>
                </v-layout>
              </v-container>
              <small class="required-text">* จำเป็น</small>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click.stop="endCalendarSubmit()"
              rounded
              class="confirm-btn"
            >
              <v-icon dark>mdi-checkbox-marked-circle-outline</v-icon
              >&nbsp;ยืนยัน
            </v-btn>
            <v-btn
              fab
              small
              @click.stop="endCalendardialog = false"
              rounded
              class="close-btn"
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        class="elegant-snackbar"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </v-container>
</template>
<script>
import AlertAssistant_teacher from "../../components/admin/alertAssistant_teacher.vue";
import AlertAssistant_teacher2 from "../../components/admin/alertAssistant_teacher2.vue";
import AlertAssistant_teacher3_licence from "../../components/admin/alertAssistant_teacher3_licence.vue";

export default {
  components: {
    AlertAssistant_teacher,
    AlertAssistant_teacher2,
    AlertAssistant_teacher3_licence
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      user: {},
      users: [],
      edituser: [],
      edituserdialog: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      user_system_items: [
        {
          text: "ข้อมูลผู้ใช้งานระบบ ข้าราชการครูและบุคลาการทางการศึกษา",
          icon: "mdi-account-arrow-right",
          to: "/admin/personnel"
        },
        {
          text: "ข้อมูลผู้ใช้งานระบบ วิทยาลัย สอจ.สถานบัน กจ2 Admin",
          icon: "mdi-account-arrow-right",
          to: "/admin/user"
        },
        {
          text: "สถานะผู้ใช้งานระบบ",
          icon: "mdi-account-cog",
          to: "/admin/user_status"
        }
      ],

      college_items: [
        {
          text: "ข้อมูลประเภทสถานศึกษา",
          icon: "mdi-office-building",
          to: "/admin/collegetype"
        },
        {
          text: "ข้อมูลสถาบันการอาชีวศึกษา",
          icon: "mdi-office-building",
          to: "/admin/veivocal"
        },
        {
          text: "ข้อมูลสถานศึกษา",
          icon: "mdi-office-building",
          to: "/admin/college"
        },
        {
          text: "ข้อมูลรายละเอียดสถานศึกษา",
          icon: "mdi-office-building",
          to: "/admin/collegeinfo"
        }
      ],

      period_config: [
        {
          text: "กำหนดการสมัคร ผู้บริหารสถานศึกษา (ผอ. / รอง ผอ.)",
          icon: "mdi-calendar",
          to: "/admin/timelines/examination_deputyDirector"
        },
        {
          text: "กำหนดการครูผู้ช่วย",
          icon: "mdi-calendar",
          to: "/admin/timelines/report_assistantteacher"
        },
        {
          text: "กำหนดการย้ายข้าราชการครู",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_teachers"
        },
        {
          text: "กำหนดการย้ายสายบริหาร",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_directors"
        },
        {
          text: "กำหนดการอัตรากำลัง",
          icon: "mdi-calendar",
          to: "/admin/sys_config_collegemanpower"
        }
      ],

      user_items: [
        {
          text: "จัดการคำนำหน้าชื่อ",
          icon: "mdi-format-title",
          to: "/admin/prefix"
        },
        {
          text: "ข้าราชการครูและบุคลากร (หลัก)",
          icon: "mdi-account",
          to: "/admin/personnel_tem"
        },
        {
          text: "บุคลากร งานอัตรากำลัง (รอง)",
          icon: "mdi-account",
          to: "/admin/personnel_etc"
        },
        {
          text: "ข้อมูลขอรับข้อมูลบุคคล",
          icon: "mdi-account-convert",
          to: "/admin/collegepersonnelreq"
        },
        {
          text: "ข้อมูลคุณวุฒิการศึกษา",
          icon: "mdi-school",
          to: "/admin/personnel_education"
        },
        {
          text: "ข้อมูลประสบการณ์",
          icon: "mdi-airplane",
          to: "/admin/personnel_experience"
        },
        {
          text: "ข้อมูลประวัติการรับราชการ",
          icon: "mdi-access-point-network",
          to: "/admin/personnel_work_history"
        },
        {
          text: "ข้อมูลผลงาน รางวัล",
          icon: "mdi-trophy-award",
          to: "/admin/personnel_award"
        },
         {
          text: "จัดการข้อมูลคุณวุฒิระดับการศึกษา",
          icon: "mdi-trophy-award",
          to: "/admin/cls_degree"
        }
      ],

      about_brach: [
        {
          text: "สาขาวิชาเอก งานย้ายสายการสอน",
          icon: "mdi-source-branch",
          to: "/admin/branch"
        },
        {
          text: "สาขางาน งานย้ายสายการสอน",
          icon: "mdi-source-branch",
          to: "/admin/branch_sub"
        },
        {
          text: "ประเภทวิชา",
          icon: "mdi-source-branch",
          to: "/admin/subject_type"
        },
        {
          text: "สาขาวิชา/สาขางาน",
          icon: "mdi-source-branch",
          to: "/admin/rate_work_course_std"
        },
        {
          text: "หลักสูตรวิชาชีพระยะสั้น",
          icon: "mdi-source-branch",
          to: "/admin/short_course"
        }
      ],

      movement38_items: [
        {
          text: "กำหนดการย้าย 38 ค.(2)",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_38"
        },
        {
          text: "ตำแหน่งว่าง",
          icon: "mdi-calendar",
          to: "/admin/man_power_38"
        },
        {
          text: "ย้าย 38 ค.(2)",
          icon: "mdi-calculator",
          to: "/admin/transference_personnel_38"
        }
      ],

      movement_items: [
        {
          text: "กำหนดการย้ายครู",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_teachers"
        },
        {
          text: "ย้ายครู ประกอบการพิจารณา",
          icon: "mdi-account-switch",
          to: "/admin/transference_location_detail"
        },
        {
          text: "ย้ายครู รายละเอียด",
          icon: "mdi-account-switch",
          to: "/admin/transference_location"
        },
        {
          text: "ย้ายครู [ประมวลผลแบบ 1]",
          icon: "mdi-calculator",
          to: "/admin/transference_personnel"
        },
        {
          text: "ย้ายครู [กรณีพิเศษ]",
          icon: "mdi-calculator",
          to: "/admin/transference_personnel_sp"
        },
        {
          text: "ประมวลผลการย้าย [ประมวลผลแบบ 2]",
          icon: "mdi-calculator",
          to: "/admin/process_transfer"
        },
        {
          text: "ประมวลผลการย้าย สับเปลี่ยนแบบปกติ แบบที่ 3]",
          icon: "mdi-calculator",
          to: "/admin/process_transfer_switch_normal"
        },
        {
          text: "ประมวลผลการย้าย [ประมวลผลแบบ 4 สับเปลี่ยน]",
          icon: "mdi-calculator",
          to: "/admin/process_transfer_switch"
        },
        {
          text: "สรุปผลการย้าย",
          icon: "mdi-newspaper",
          to: "/admin/conditons_transfer_success"
        },
        {
          text: "การรายงานตัว ณ วิทยาลัย",
          icon: "mdi-calculator",
          to: "/admin/conditons_transfer_success_reportmv"
        }
      ],

      movement_govem_manpoweritems: [
        {
          text: "กำหนดการรายงานข้อมูลกรอบอัตรากำลัง",
          icon: "mdi-calendar",
          to: "/admin/gov_em/period_mgovem"
        },
        {
          text: "การรายงานกรอบอัตรากำลังของสถานศึกษา",
          icon: "mdi-calendar",
          to: "/admin/gov_em/Governmentemployeereportadmin"
        },

        {
          text: "กรอบอัตรากำลัง",
          icon: "mdi-calendar",
          to: "/admin/gov_em/government_employee"
        }
      ],

      movement_govem_manpowerSalaryitems: [
        {
          text: "คำตอบแทน ปี พ.ศ. 2568",
          icon: "mdi-calendar",
          to: "/admin/gov_em/salary_gov_2568"
        }
      ],

      movement_govem_items: [
        {
          text: "กำหนดการย้าย พนักงานราชการ",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_govem"
        },
        {
          text: "ย้ายพนักงานราชการ ประกอบการพิจารณา",
          icon: "mdi-account-switch",
          to: "/admin/gov_em/transference_location_detail"
        },
        {
          text: "ย้ายพนักงานราชการ รายละเอียด",
          icon: "mdi-account-switch",
          to: "/admin/gov_em/transference_location"
        },

        {
          text: "ประมวลผลการย้าย [ประมวลผลแบบ 1]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/transference_personnel"
        },

        {
          text: "ประมวลผลการย้าย [ประมวลผลแบบ 2]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/process_transfer"
        },
        {
          text: "ประมวลผลการย้าย สับเปลี่ยนแบบปกติ แบบที่ 3]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/process_transfer_switch_normal"
        },
        {
          text: "ประมวลผลการย้าย [ประมวลผลแบบ 4 สับเปลี่ยน]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/process_transfer_switch"
        },
        {
          text: "สรุปผลการย้าย",
          icon: "mdi-newspaper",
          to: "/admin/gov_em/conditons_transfer_success"
        }
      ],

      movement_manage_items: [
        {
          text: "กำหนดการ ย้ายสายบริหาร",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_directors"
        },
        {
          text: "สายงานบริหารสถานศึกษา",
          icon: "mdi-account-switch",
          to: "/admin/transference_manage_main"
        },
        {
          text: "สายงานบริหารสถานศึกษา ประกอบการพิจารณา",
          icon: "mdi-account-switch",
          to: "/admin/transference_manage_location_detail"
        },
        {
          text: "สายงานบริหารสถานศึกษา รายละเอียด",
          icon: "mdi-account-switch",
          to: "/admin/transference_manage_location"
        },
        {
          text: "สายงานบริหารสถานศึกษา [ประมวลผลแบบ 1]",
          icon: "mdi-calculator",
          to: "/admin/transference_manage"
        }
      ],

      condition_items: [
        {
          text: "เงือนไขการรับย้ายของสถานศึกษา",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/conditions_transfer"
        },
        {
          text: "เงือนไขการรับย้ายสาขาวิชา",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/conditions_branch"
        }
      ],

      condition_govem_items: [
        {
          text: "ข้อมูลอัตรา พนักงานราชการ",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/man_power_govem"
        },

        {
          text: "รายงานตำแหน่งว่าง พนักงานราชการ ของส่วนกลาง",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/conditions_branch_govem"
        },
        {
          text: "รายงานตำแหน่งว่าง พนักงานราชการ ของสถานศึกษา",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/government_employee_report"
        },
        {
          text: "รายงานตำแหน่งว่าง พนักงานราชการ รายละเอียด",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/college_manpower_govem"
        }
      ],

      commiteevecpro: [
        {
          text: "รายงานคณะกรรมการ สอจ.",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/commiteevecreport"
        },
        {
          text: "รายชื่อกรรมการ สอจ.",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/commiteevecpro"
        }
      ],

      official_book: [
        {
          text: "คำสั่งแต่งตั้งรักษาการในตำแหน่ง",
          icon: "mdi-bookmark-check",
          to: "/admin/Order_appoint"
        },
        {
          text: "ศูนย์กลางส่งออกเอกสาร ประกอบการพิจารณาย้าย",
          icon: "mdi-bookmark-check",
          to: "/admin/transference_export_report"
        }
      ],

      official_book_govem: [
        {
          text: "คำสั่งย้าย",
          icon: "mdi-bookmark-check",
          to: "/admin/gov_em/Order_appoint"
        },
        {
          text: "การรายงานตัว ปลายทาง",
          icon: "mdi-calculator",
          to: "/admin/gov_em/conditons_transfer_success_reportmv"
        }
      ],

      manpower_move: [
        {
          text: "ข้อมูลอัตรากำลังสถานศึกษา สำหรับย้าย",
          icon: "mdi-account-multiple",
          to: "/admin/man_power"
        },
        {
          text: "ข้อมูลอัตรากำลัง จ.18",
          icon: "mdi-account-multiple",
          to: "/admin/jor18"
        }
      ],

      human_items: [
        {
          text: "กำหนดการ รายงานอัตรากำลัง",
          icon: "mdi-calendar",
          to: "/admin/sys_config_collegemanpower"
        },
        {
          text: "อัตรากำลังสถานศึกษา",
          icon: "mdi-account-multiple",
          to: "/admin/personnel_etc"
        },
        {
          text: "ข้อมูลลูกจ้างชั่วคราว",
          icon: "mdi-account-multiple",
          to: "/admin/personnel_etc_tem"
        },
        {
          text: "รายงานอัตรากำลังประจำปี สถานศึกษา",
          icon: "mdi-account-multiple",
          to: "/admin/rate_work_g"
        },
        {
          text: "จำนวนนักเรียน ศธ.02",
          icon: "mdi-account-multiple",
          to: "/admin/power_rate/rate_work_college"
        }
      ],

      humanreport_items: [
        {
          text: "กำหนดการ",
          icon: "mdi-calendar",
          to: "/admin/sys_config_collegemanpower_report"
        },
        {
          text: "จัดการเลขที่ตำแหน่งว่าง",
          icon: "mdi-account-multiple",
          to: "/admin/jor18"
        },
        {
          text: "สถานะการรายงาน",
          icon: "mdi-account-multiple",
          to: "/admin/jor18_report"
        },
        {
          text: "การรายงาน (เลขที่ตำแหน่ง)",
          icon: "mdi-account-multiple",
          to: "/admin/college_manpower"
        }
      ],

      prepare_items: [
        {
          text: "กำหนดการ ครูผู้ช่วย",
          icon: "mdi-calendar",
          to: "/admin/timelines/report_assistantteacher"
        },
        {
          text: "เรียกรายงานตัวครูผู้ช่วย/รอบ",
          icon: "mdi-account-settings",
          to: "/admin/assistant_teacher_report/manage_assistant_teacher"
        },
        {
          text: "ข้อมูลเลขที่ตำแหน่ง วิทยาลัย ใช้รายงานตัว",
          icon: "mdi-account-settings",
          to: "/admin/assistant_teacher_report/manage_college_manpower"
        },
        {
          text: "การรายงานตัวเลือกสถานศึกษา",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_report/teacher_college_manpower_report"
        },
        {
          text: "การรายงานตัว ณ สถานศึกษา",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_report/manage_assistant_CollegeReport"
        },
        {
          text: "การรายงานตัว ณ สถานศึกษา(โอนย้าย)",
          icon: "mdi-account-star",
          to:
            "/admin/assistant_teacher_report/manage_assistant_CollegeReportTran"
        }
      ],

      prepare_items_committee: [
        {
          text: "รอบบรรจุ",
          icon: "mdi-calendar",
          to:
            "/admin/assistant_teacher_report/personnel_temporary_assistant_period"
        },
          {
          text: "เสนอผู้ทรงคุณวุฒิ",
          icon: "mdi-account-settings",
          to:
            "/admin/assistant_teacher_report/assistantcommitteequalified"
        },

        {
          text: "เสนอคณะกรรมการ",
          icon: "mdi-account-settings",
          to:
            "/admin/assistant_teacher_report/manage_assistant_teacher_committee"
        },
        {
          text: "การประเมิน/ตรวจสอบ",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher"
        },
        {
          text: "รายงานผลประเมิน(ครบ)",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_reports"
        },
        {
          text: "ข้อมูลเอกสารแนบ",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_report/manage_assistant_teacher_doc"
        },
        {
          text: "ครูผู้ช่วย",
          icon: "mdi-account-star",
          to: "/admin/manage_assistant_teacher_data"
        }
      ],

      news_manual: [
        { text: "ข่าวสาร", icon: "mdi-book", to: "/admin/news_s" },
        {
          text: "คู่มือใช้งาน",
          icon: "mdi-book-open-page-variant",
          to: "/admin/manual_s"
        }
      ],

      appoint_sedirector: [
        {
          text: "กำหนดการ คัดเลือก รองผู้อำนวยการวิทยาลัย",
          icon: "mdi-calendar",
          to: "/admin/timelines/examination_deputyDirector"
        },
        { text: "ผู้สมัคร", icon: "mdi-book", to: "/admin/sedirector_app" },
        {
          text: "ภาค ก.",
          icon: "mdi-book",
          to: "/admin/sedirector_assessment/sedirector_app_a"
        },
        {
          text: "ภาค ข",
          icon: "mdi-book",
          to: "/admin/sedirector_assessment/sedirector_app_b"
        },
        {
          text: "ประกาศผล",
          icon: "mdi-book",
          to: "/admin/sedirector_assessment/sedirector_app_notice"
        }
      ],

      appoint_sedirector2: [
        {
          text: "ตำแหน่งว่างสถานศึกษา",
          icon: "mdi-book",
          to: "/admin/sedirector_assessment/director_college_manpower"
        },
        {
          text: "รายงานตัวเลือกสถานศึกษา",
          icon: "mdi-book",
          to: "/admin/sedirector_assessment/sedirector_app_choose"
        },
        {
          text: "รายงาน ณ สถานศึกษา",
          icon: "mdi-book",
          to: "/admin/sedirector_assessment/sedirector_app_a"
        }
      ],

      appoint_director: [
        {
          text: "กำหนดการ คัดเลือก ผู้อำนวยการวิทยาลัย",
          icon: "mdi-calendar",
          to: "/admin/timelines/examination_Director"
        },
        { text: "ผู้สมัคร", icon: "mdi-book", to: "/admin/director_app" },
        {
          text: "ภาค ก",
          icon: "mdi-book",
          to: "/admin/director_assessment/director_app_a"
        },
        {
          text: "ภาค ข",
          icon: "mdi-book",
          to: "/admin/director_assessment/director_app_b"
        },
        {
          text: "ภาค ค",
          icon: "mdi-book",
          to: "/admin/director_assessment/director_app_c"
        },
        {
          text: "ประกาศผล",
          icon: "mdi-book",
          to: "/admin/director_assessment/director_app_notice"
        }
      ],

      appoint_director2: [
        {
          text: "ตำแหน่งว่างสถานศึกษา",
          icon: "mdi-book",
          to: "/admin/director_assessment/director_college_manpower"
        },
        {
          text: "รายงานตัวเลือกสถานศึกษา",
          icon: "mdi-book",
          to: "/admin/director_assessment/director_app_choose"
        },
        {
          text: "รายงาน ณ สถานศึกษา",
          icon: "mdi-book",
          to: "/admin/director_assessment/director_app_report_college"
        }
      ],

      endCalendardialog: false,
      confirmPassword: "",
      show1: false,
      updateSystems: {}
    };
  },

  async mounted() {
    await this.userQueryAll();
  },

  computed: {
    filteredUserItems() {
      if (this.user.userauthority_govem === "1") {
        return this.user_items.filter(
          item =>
            item.to !== "/admin/personnel_etc" &&
            item.to !== "/admin/collegepersonnelreq"
        );
      }
      return this.user_items;
    }
  },

  methods: {
    async clearUpdate() {
      Swal.fire({
        title: "Reset For Update",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ดำเนินการ",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          let result = await this.$http.post("user.reset.update.php", {
            ApiKey: this.ApiKey
          });
          if (result.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการซ้ำ",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },
    async endCalendarSubmit() {
      if (this.$refs.endCalendarform.validate()) {
        this.updateSystems.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "period.update.allsystem.php",
          this.updateSystems
        );

        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการปิดกำหนดการในระบบเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },
    async endCalendar() {
      this.endCalendardialog = true;
    },
    async userQueryAll() {
      let result;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user = result.data;
    },
    async userUpdate() {
      let result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: this.user.user_ID
      });
      this.edituser = result.data;
      this.edituser.p_word = "";
      this.edituserdialog = true;
    },
    async edituserSubmit() {
      if (this.$refs.edituserform.validate()) {
        this.edituser.ApiKey = this.ApiKey;
        let result = await this.$http.post("user.update.php", this.edituser);
        if (result.data.status == true) {
          this.user = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.userQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.edituserdialog = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* === Main Container === */
.elegant-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  min-height: 100vh;
  padding: 24px;
  font-family: "Inter", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* === User Card Section === */
.elegant-user-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  margin-bottom: 24px;
  padding: 32px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15) !important;
  }
}

.user-info-section {
  margin-bottom: 16px;
}

.user-title {
  color: #1a202c;
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 12px;
  letter-spacing: -0.025em;
}

.user-name {
  color: #4a5568;
  font-weight: 500;
  font-size: 1.25rem;
  margin-bottom: 8px;
}

.user-status {
  color: #718096;
  font-weight: 400;
  font-size: 1.1rem;
}

/* === Action Buttons === */
.action-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}

.elegant-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-width: 2px !important;

  &:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0) scale(0.98);
  }
}

/* === Navigation Bar === */
.navigation-bar {
  background: rgba(255, 255, 255, 0.9);

  border-radius: 16px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-btn {
  margin: 4px 6px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
}

/* === Main Cards === */
.elegant-main-card {
  background: rgba(255, 255, 255, 0.98);

  border-radius: 20px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  margin-bottom: 24px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12) !important;
  }
}

/* === Section Headers === */
.section-header {
  background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%) !important;
  color: white !important;
  padding: 20px 24px !important;
  margin: 0 !important;
  border: none !important;
}

.section-title {
  color: white !important;
  font-weight: 600;
  font-size: 1.375rem;
  letter-spacing: -0.025em;
  margin: 0;
}

/* === Color-specific Headers === */
.blue-header {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%) !important;
}

.pink-header {
  background: linear-gradient(135deg, #c2185b 0%, #f06292 100%) !important;
}

.purple-header {
  background: linear-gradient(135deg, #7b1fa2 0%, #ba68c8 100%) !important;
}

.green-header {
  background: linear-gradient(135deg, #388e3c 0%, #66bb6a 100%) !important;
}

.green-dark-header {
  background: linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%) !important;
}

.orange-header {
  background: linear-gradient(135deg, #f57c00 0%, #ffb74d 100%) !important;
}

.brown-header {
  background: linear-gradient(135deg, #5d4037 0%, #8d6e63 100%) !important;
}

.error-header {
  background: linear-gradient(135deg, #c62828 0%, #ef5350 100%) !important;
}

.indigo-header {
  background: linear-gradient(135deg, #303f9f 0%, #5c6bc0 100%) !important;
}

/* === Section Cards === */
.elegant-section-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
    border-color: rgba(13, 148, 136, 0.3) !important;
  }
}

/* === Color-specific Sections === */
.branch-section:hover {
  border-color: rgba(63, 81, 181, 0.3) !important;
}

.error-section:hover {
  border-color: rgba(198, 40, 40, 0.3) !important;
}

.purple-section:hover {
  border-color: rgba(123, 31, 162, 0.3) !important;
}

.brown-section:hover {
  border-color: rgba(93, 64, 55, 0.3) !important;
}

/* === Section Toolbars === */
.section-toolbar {
  background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.blue-toolbar {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%) !important;
}

.pink-toolbar {
  background: linear-gradient(135deg, #c2185b 0%, #f06292 100%) !important;
}

.purple-toolbar {
  background: linear-gradient(135deg, #7b1fa2 0%, #ba68c8 100%) !important;
}

.green-toolbar {
  background: linear-gradient(135deg, #388e3c 0%, #66bb6a 100%) !important;
}

.green-dark-toolbar {
  background: linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%) !important;
}

.orange-toolbar {
  background: linear-gradient(135deg, #f57c00 0%, #ffb74d 100%) !important;
}

.toolbar-title {
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: -0.025em;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  font-size: 1.25rem;
}

/* === Lists === */
.elegant-list {
  background: transparent !important;
  padding: 8px 0;
}

.elegant-list-item {
  border-radius: 8px;
  margin: 2px 8px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: linear-gradient(
      135deg,
      rgba(13, 148, 136, 0.08) 0%,
      rgba(20, 184, 166, 0.05) 100%
    ) !important;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(13, 148, 136, 0.15);
  }

  &::before {
    background: transparent !important;
  }
}

.list-icon {
  color: #0d9488;
  transition: all 0.25s ease;
}

.elegant-list-item:hover .list-icon {
  color: #0f766e;
  transform: scale(1.1);
}

.list-title {
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.5;
  transition: color 0.25s ease;
}

.elegant-list-item:hover .list-title {
  color: #0f766e;
  font-weight: 600;
}

/* === Dialog Styles === */
.elegant-dialog {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 20px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.dialog-header {
  border-radius: 16px 16px 0 0;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
}

.dialog-content {
  padding: 24px !important;
}

.user-info {
  font-size: 1.1rem;
  font-weight: 500;

  margin-bottom: 16px;
  padding: 12px;
  background: rgba(249, 250, 251, 0.8);
  border-radius: 8px;
  border-left: 4px solid #0d9488;
}

.elegant-input {
  .v-text-field__details {
    padding-left: 0;
  }

  .v-input__control {
    .v-input__slot {
      background: rgba(255, 255, 255, 0.9) !important;
      border-radius: 12px !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: rgba(255, 255, 255, 1) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }
    }
  }
}

.elegant-divider {
  background: linear-gradient(
    90deg,
    transparent 0%,
    #e5e7eb 20%,
    #e5e7eb 80%,
    transparent 100%
  );
  margin: 16px 0;
}

.required-text {
  font-style: italic;
}

.dialog-actions {
  padding: 16px 24px 24px !important;
  gap: 12px;
}

.cancel-btn {
  background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(107, 114, 128, 0.3);
  }
}

.submit-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(251, 191, 36, 0.3);
  }
}

.confirm-btn {
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(34, 197, 94, 0.3);
  }
}

.close-btn {
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 8px 24px rgba(220, 38, 38, 0.3);
  }
}

/* === Snackbar === */
.elegant-snackbar {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

/* === Special Text === */
.special-text {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

#fontsizest {
  font-size: 1.25rem;
  font-weight: 700;
  color: #dc2626;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* === Responsive Design === */
@media (max-width: 768px) {
  .elegant-container {
    padding: 16px;
  }

  .elegant-user-card {
    padding: 20px !important;
  }

  .user-title {
    font-size: 1.25rem;
  }

  .user-name {
    font-size: 1.1rem;
  }

  .action-buttons {
    justify-content: center;
    margin-top: 16px;
  }

  .navigation-bar {
    padding: 16px;
  }

  .nav-btn {
    margin: 4px 2px;
    font-size: 0.85rem;
  }

  .toolbar-title {
    font-size: 0.95rem;
  }

  .dialog-content {
    padding: 16px !important;
  }
}

@media (max-width: 480px) {
  .elegant-container {
    padding: 12px;
  }

  .section-title {
    font-size: 1.2rem;
  }

  .toolbar-title {
    font-size: 0.9rem;
  }

  .list-title {
    font-size: 0.9rem;
  }

  .nav-btn {
    font-size: 0.8rem;
    padding: 6px 12px;
  }
}

/* === Animations === */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.elegant-section-card {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.elegant-section-card:nth-child(1) {
  animation-delay: 0.1s;
}
.elegant-section-card:nth-child(2) {
  animation-delay: 0.2s;
}
.elegant-section-card:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.elegant-list-item {
  animation: slideInLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* === Focus States for Accessibility === */
.elegant-btn:focus,
.nav-btn:focus,
.elegant-list-item:focus {
  outline: 2px solid #0d9488;
  outline-offset: 2px;
}

.elegant-input:focus-within {
  .v-input__slot {
    border-color: #0d9488 !important;
    box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.2) !important;
  }
}

/* === Custom Scrollbar === */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #0d9488, #14b8a6);
  border-radius: 4px;
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #0f766e, #0d9488);
}

::-webkit-scrollbar-corner {
  background: #f1f5f9;
}

/* === Print Styles === */
@media print {
  .elegant-container {
    background: white !important;
    padding: 0 !important;
  }

  .elegant-user-card,
  .elegant-main-card,
  .elegant-section-card {
    box-shadow: none !important;
    border: 1px solid #e5e7eb !important;
  }

  .action-buttons,
  .navigation-bar {
    display: none !important;
  }
}

/* === High Contrast Mode === */
@media (prefers-contrast: high) {
  .elegant-container {
    background: white !important;
  }

  .elegant-user-card,
  .elegant-main-card,
  .elegant-section-card {
    background: white !important;
    border: 2px solid black !important;
  }

  .list-title,
  .user-title,
  .user-name,
  .section-title {
    color: black !important;
  }
}

/* === Reduced Motion === */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* === Additional Enhancements === */
.elegant-container::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 20% 80%,
      rgba(13, 148, 136, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(59, 130, 246, 0.1) 0%,
      transparent 50%
    );
  pointer-events: none;
  z-index: -1;
}

/* === Loading States === */
.elegant-section-card.loading {
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
    );
    animation: shimmer 1.5s infinite;
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* === Interactive Enhancements === */
.elegant-list-item {
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(13, 148, 136, 0.1),
      transparent
    );
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }
}

/* === Glass Morphism Enhancement === */
.elegant-main-card,
.elegant-section-card {
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
}

/* === Dark Theme Support === */
@media (prefers-color-scheme: dark) {
  .elegant-container {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  }

  .elegant-user-card,
  .elegant-main-card,
  .elegant-section-card {
    border-color: rgba(71, 85, 105, 0.3);
  }
}
</style>
